module.exports = __webpack_public_path__ + "img/overheads-sales-expenses.cbe9d373.svg";